import { useLoader } from "@/app/hook/use-loader";
import { Spin } from "@/base/components/index";
import { cx } from "antd-style";
import { LoaderProps } from "../types/index";
import { useLoaderStyles } from "./loader.styles";

export const Loader = ({ className }: LoaderProps) => {
  const { styles } = useLoaderStyles();
  const { spinning } = useLoader();

  return (
    <div className={cx(styles.root, className)}>
      <Spin
        fullscreen
        size="large"
        spinning={spinning}
        className={styles.spin}
      />
    </div>
  );
};
